<template>
  <div></div>
</template>

<script>
import Qr from './Qr'
import { OAUTH_INFO_API_URL } from 'dygc'

export default {
  name: 'OverlayTip',
  props: {
    text: String
  },
  created() {
    const h = this.$createElement
    const origin = window.location.origin
    this.$msgbox({
      message: h('div', [
        h('div', { attrs: { class: 'flex items-center justify-center' } }, [
          h('img', { attrs: { src: '/assets/img/common/weixin.png', width: '16', class: 'mr-1' } }),
          h('span', { attrs: { class: 'text-medium text-theme-black-650 align-middle' } }, this.text)
        ]),
        h('div', { attrs: { class: 'text-center mt-4' } }, [
          h(Qr, {
            props: {
              url: `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(`${origin}/mobile${location.search}`)}`
            }
          })
        ])
      ]),
      showClose: false,
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickModal: false
    })
  }
}
</script>
